import { getCookie, setCookie } from '@/js/utils/browser';
import { COOKIES } from '@/js/constants';

type Options = {
  fade: boolean;
};

export class GDPR {
  el: HTMLElement;
  buttonEl: HTMLElement;
  options: Options;
  constructor(selector: string, options: Partial<Options> = {}) {
    this.options = {
      fade: false,
      ...options,
    };
    const el = document.querySelector(selector) as null | HTMLElement;
    this.el = el!;
    this.buttonEl = null!;
    if (this.el) {
      this.initialize();
    }
  }

  private initialize() {
    if (getCookie(COOKIES.GDPR)) {
      this.el.parentNode?.removeChild(this.el);
    } else {
      this.el.classList.add('is-active');
      this.buttonEl = this.el.querySelector('.js-gdpr-button') as HTMLElement;
      this.bind();
      // フェードアウト時のみかかるように
      if (this.options.fade) {
        this.el.classList.add('has-fade');
      }
    }
  }

  private bind() {
    this.buttonEl.addEventListener('click', this.handleClick.bind(this));
  }

  private handleClick() {
    this.el.addEventListener(
      this.options.fade ? 'transitionend' : 'click',
      () => {
        this.el.parentNode?.removeChild(this.el);
      },
      { once: true },
    );
    setCookie({ name: COOKIES.GDPR, value: 'true', expires: 24 * 365 });
    this.el.classList.remove('is-active');
  }
}
